module.exports = __webpack_public_path__ + "img/seal-axh-official.ad1c8ca0.png";